import { connect } from 'react-redux';
import { getBusinessSummary } from '../../../store/summary/duck';
import { renderHeaderButton } from '../../../store/headerButtonControl/duck';
import {
  getAdviserDashboard,
  connectedUserPolicies,
  policyCount,
  adviserBusinessAnalysis,
  getDuePolicy,
  fetchFigureAdviser,
  updateFigureAdviser,
  updateAdviserBusiness,
  fetchAdviserBusiness,
  fetchAdviserTeamDetail,
  getPaidUpPolicies
} from '../../../store/adviserDashboard/duck';
import { handleSignOut, updateUserDetails, defaultMessages } from '../../../store/user/duck';
import { selectedLocale } from '../../../store/locale/action';
import { submitClient } from '../../../store/client/duck';
import AdvisorDashboardComponent from './component';

import { injectIntl } from 'react-intl';
import { endGuideline, runGuideline } from '../../../store/guideline/duck';
import { initTrackingPhase } from '../../../store/client/duck';
import { toggleDialog, toggleSwipeable } from '../../../store/control/duck';

const AdvisorDashboardContainer = connect(
  // Map state to props
  state => ({
    opportunityCount: state.adviserDashboard.opportunityCount,
    adjustedBusinessVol: state.adviserDashboard.adjustedBusinessVol,
    activeTrackRecord: state.adviserDashboard.activeTrackRecord,
    totalBusinessVol: state.adviserDashboard.totalBusinessVol,
    userDetails: state.user.userDetails,
    defaultMessage: state.user.defaultMessage,
    businessSummaryData: state.summary.businessSummaryData,
    businessSummaryPhase: state.summary.businessSummaryPhase,
    dashboardCategoryData: state.policy.dashboardCategoryData,
    averageCoverageData: state.adviserDashboard.averageCoverageData,
    averagePremiumData: state.adviserDashboard.averagePremiumData,
    //GetConnectedUsers: state.adviserDashboard.GetConnectedUsers,
    getUsersGender: state.adviserDashboard.getUsersGender,
    // getActiveReminder: state.adviserDashboard.getActiveReminder,
    getClientStatusData: state.adviserDashboard.getClientStatusData,
    GetConnectedUsersBirthday: state.adviserDashboard.GetConnectedUsersBirthday,
    // GetUsersPolicyDueData: state.adviserDashboard.GetUsersPolicyDueData,
    GetUsersWithoutPolicyData: state.adviserDashboard.GetUsersWithoutPolicyData,
    noPolicyPhase: state.adviserDashboard.noPolicyPhase,
    policiesData: state.adviserDashboard.policiesData,
    policyCountData: state.adviserDashboard.policyCountData,
    newReferralCount: state.referral.newReferralCount,
    updateFigureAdviserPhase: state.adviserDashboard.updateFigureAdviserPhase,
    getFigureAdviserPhase: state.adviserDashboard.getFigureAdviserPhase,
    figureAdviserData: state.adviserDashboard.figureAdviserData,
    getClientSavingILASPolicyData: state.adviserDashboard.getClientSavingILASPolicyData,
    PastBirthdayOfUsers: state.adviserDashboard.PastBirthdayOfUsers,
    updateQuarterTargetPhase: state.adviserDashboard.updateQuarterTargetPhase,
    adviserBusiness: state.adviserDashboard.adviserBusiness,
    getAdviserTeamDetail: state.adviserDashboard.getAdviserTeamDetail,
    exchangeRate: state.user.exchangeRate,
    GetConnectedUsersDiscCount: state.adviserDashboard.GetConnectedUsersDiscCount,
    clientTagUsage: state.adviserDashboard.clientTagUsage,
    clientData: state.client.clientData,
    enableTrackingPhase: state.client.enableTrackingPhase,
    policyDueData: state.adviserDashboard.policyDueData,
    // paidUpPolicyClients: _.get(state, 'adviserDashboard.paidUpPolicyClients', []),
    subscriptions: state.userSubscription.subscriptions,
    clientDetails: state.client.clientDetails,
    policyDueClientCount: state.assistant.policyDueClientCount,
    remindMeClientCount: state.assistant.remindMeClientCount,
    birthdayClientCount: state.assistant.birthdayClientCount,
    paidUpPolicyClientCount: state.assistant.paidUpPolicyClientCount,
    clients: state.client.clientData,
    bigDataSwipeable: state.control.bigDataSwipeable
  }),
  // Map actions to props
  {
    getBusinessSummary,
    getAdviserDashboard,
    adviserBusinessAnalysis,
    connectedUserPolicies,
    policyCount,
    getDuePolicy,
    handleSignOut,
    updateUserDetails,
    updateFigureAdviser,
    fetchFigureAdviser,
    defaultMessages,
    selectedLocale,
    updateAdviserBusiness,
    fetchAdviserBusiness,
    fetchAdviserTeamDetail,
    runGuideline,
    initTrackingPhase,
    submitClient,
    getPaidUpPolicies,
    renderHeaderButton,
    toggleDialog,
    toggleSwipeable,
    endGuideline
  }
)(AdvisorDashboardComponent);

export default injectIntl(AdvisorDashboardContainer);
